<template>
  <div class="item-container">
    <a href="" @click.prevent="clicked" @mouseover="hover= true" @mouseleave="hover = false" :class="{'dropdown-item': true, disabled: disabled }">
      <slot/>
    </a>
    <div v-if="hover && tooltip" class="tooltip">
      {{ tooltip }}
      <div class="tooltip-arrow"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DropdownItem',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
    },
  },
  data() {
    return {
      hover: false,
    };
  },
  methods: {
    clicked() {
      if (!this.disabled) {
        this.$emit('clicked');
      }
    },
  },
};
</script>

<style>
.item-container {
  position: relative;
}
.tooltip {
  position: absolute;
  background-color: #1C1E1F;
  color: white;
  z-index: 10000;
  font-size: 14px;
  padding: 10px;
  border-radius: 4px;
  margin: 0 10px;
  top: calc(-200% - 25px);
}
.tooltip-arrow {
  position: absolute;
  left: calc(50% - 12px);
  bottom: -6px;
  width: 24px;
  height: 24px;
  background-color: #1C1E1F;
  transform: rotate(45deg);
  z-index: -1;
}
.dropdown-item {
  color: #575756;
  padding: .25rem 1rem;
  margin: .25rem 0;
  font-size: 16px;
  font-weight: 500;
  display: block;
}
.dropdown-item:hover {
  background-color: #edf2f7;
}
.dropdown-item.disabled {
  cursor: not-allowed;
  color: #9AA6AE;
}
.dropdown-item.disabled:hover {
  background-color: transparent;
}
</style>
